<script>
	import { state } from "../store";
	import WriteQuestion from "./writeQuestion.svelte";
	import ReadQuestion from "./readQuestion.svelte";

	$: game = $state.game;
	$: question = game.question;
</script>

<div class="container">
	{#if question}
		{#if question.type === "write"}
			<WriteQuestion />
		{/if}
		{#if question.type === "read"}
			<ReadQuestion
				{question}
			/>
		{/if}
	{/if}
</div>

<style>
	.container {
		display: flex;
		flex-direction: column;
	}


</style>